'use client'
import { Collapsible } from "./ui/collapsible"
import { SidebarMenuButton, SidebarMenuItem, SidebarMenuSubButton, SidebarMenuSub, SidebarMenuSubItem } from "./ui/sidebar"
import { CollapsibleContent, CollapsibleTrigger } from "@radix-ui/react-collapsible"
import Link from "next/link"
import { ChevronRightIcon } from "lucide-react"
import { type NavItem } from "./sidebar"
import { useI18n } from "@/contexts/lang-context"

function getSubMenu(item: NavItem) {
  const { t } = useI18n()
  return (
    <Collapsible
      key={item.title}
      open={'open' in item ? item.open : undefined}
      defaultOpen={false}
      className={"group/collapsible w-full"}
    >
      <SidebarMenuItem>
        <CollapsibleTrigger asChild>
          {
            'href' in item ? (
              <Link href={item.href}>
                <SidebarMenuButton tooltip={item.shouldTranslate ? t(item.title): item.title}>
                  {item.icon && item.icon}
                  <span>{item.shouldTranslate ? t(item.title) : item.title}</span>
                  <ChevronRightIcon className={`ml-auto transition-transform duration-200 group-data-[state=open]/collapsible:group-data-[slot=collapsible]/collapsible:rotate-90`} />
                </SidebarMenuButton>
              </Link>
            ) : (
              <SidebarMenuButton tooltip={item.shouldTranslate ? t(item.title) : item.title}>
                {item.icon && item.icon}
                <span>{item.shouldTranslate ? t(item.title) : item.title}</span>
              </SidebarMenuButton>
            )
          }
        </CollapsibleTrigger>
        <CollapsibleContent>
          <SidebarMenuSub>
            {
              'children' in item && item.children?.map(subItem => (
                <SidebarMenuSubItem key={item.shouldTranslate ? t(item.title) : item.title}>
                  <SidebarMenuSubButton asChild>
                    {
                      'children' in subItem && subItem.children 
                        ? getSubMenu(subItem)
                        : 'href' in subItem && (
                          <Link href={subItem.href}>
                            {subItem.icon && subItem.icon}
                            <span>{subItem.shouldTranslate ? t(subItem.title) : subItem.title}</span>
                          </Link>
                        )
                    }
                    
                  </SidebarMenuSubButton>
                </SidebarMenuSubItem>
              ))
            }
          </SidebarMenuSub>
        </CollapsibleContent>
      </SidebarMenuItem>
    </Collapsible>
  )
}

export function SidebarItems({ items }: { items: NavItem[] }) {
  const { t } = useI18n()
  return (
    <>
      {
        items.map(item => 'children' in item && item.children ? (
          <Collapsible
            key={item.title}
            open={'open' in item ? item.open : undefined}
            defaultOpen={false}
            className="group/collapsible w-full"
          >
            <SidebarMenuItem>
              <CollapsibleTrigger asChild>
                {
                  'href' in item ? (
                    <Link href={item.href}>
                      <SidebarMenuButton tooltip={item.shouldTranslate ? t(item.title) : item.title}>
                        {item.icon && item.icon}
                        <span>{item.shouldTranslate ? t(item.title) : item.title}</span>
                        <ChevronRightIcon className={`ml-auto transition-transform duration-200 group-data-[state=open]/collapsible:group-data-[slot=collapsible]/collapsible:rotate-90`} />
                      </SidebarMenuButton>
                    </Link>
                  ) : (
                    <SidebarMenuButton tooltip={item.shouldTranslate ? t(item.title) : item.title}>
                      {item.icon && item.icon}
                      <span>{item.shouldTranslate ? t(item.title) : item.title}</span>
                      <ChevronRightIcon className={`ml-auto transition-transform duration-200 group-data-[state=open]/collapsible:group-data-[slot=collapsible]/collapsible:rotate-90`} />
                    </SidebarMenuButton>
                  )
                }
              </CollapsibleTrigger>
              <CollapsibleContent>
                <SidebarMenuSub className="mx-0 ml-3.5 px-0 pl-2.5">
                  {
                    item.children?.map(subItem => 
                      'children' in subItem && subItem.children ? getSubMenu(subItem) : (
                      <SidebarMenuSubItem key={subItem.shouldTranslate ? t(subItem.title) : subItem.title}>
                        <SidebarMenuSubButton asChild>
                          {'href' in subItem ? (
                            <Link href={subItem.href}>
                              { subItem.icon && subItem.icon }
                              <span>{subItem.shouldTranslate ? t(subItem.title) : subItem.title}</span>
                            </Link>
                            ) : (
                              <SidebarMenuSubButton asChild>
                                { subItem.icon && subItem.icon }
                                <span>{subItem.shouldTranslate ? t(subItem.title) : subItem.title}</span>
                              </SidebarMenuSubButton>
                            )
                          }
                        </SidebarMenuSubButton>
                      </SidebarMenuSubItem>
                    ))
                  }
                </SidebarMenuSub>
              </CollapsibleContent>
            </SidebarMenuItem>
          </Collapsible>
        ) : (
          <SidebarMenuItem key={item.shouldTranslate ? t(item.title) : item.title}>
            {'href' in item ? (
              <Link href={item.href}>
                <SidebarMenuButton tooltip={item.shouldTranslate ? t(item.title) : item.title}>
                  {item.icon && item.icon}
                  <span>{item.shouldTranslate ? t(item.title) : item.title}</span>
                  <ChevronRightIcon className="ml-auto transition-transform duration-200 group-data-[state=open]/collapsible:group-data-[slot=collapsible]/collapsible:rotate-90" />
                </SidebarMenuButton>
              </Link>
              ) : (
                <SidebarMenuButton tooltip={item.shouldTranslate ? t(item.title) : item.title}>
                  {item.icon && item.icon}
                  <span>{item.shouldTranslate ? t(item.title) : item.title}</span>
                </SidebarMenuButton>
              ) 
            }
          </SidebarMenuItem>
        ))
      }
    </>
  )
}